export async function replaceProductDataFromCookie() {
  /** @type {{ count: number; id: number; selected: number }[]} */
  const store = await window.Dio.SHOP.STORE.getItem('CART_LIST_PRODUCTS');
  if (store) {
    const products = store;
    const productsNode = document.querySelectorAll('[data-cart-product-id]');
    const NotNull = products.length > 0 && productsNode.length > 0;

    if (NotNull && products.length === productsNode.length) {
      [...productsNode].forEach((productEl, index) => {
        productEl.querySelector('input[type="checkbox"]').checked = products[index].selected;
        productEl.querySelector('input[type="number"]').value = products[index].count;
      });
    } else if (NotNull && productsNode && products.length !== productsNode.length) {
      // eslint-disable-next-line no-console
      console.warn('Products count in cookie doesnt much with products in cart');
    } else {
      // eslint-disable-next-line no-console
      console.warn('Store "CART_LIST_PRODUCTS" not found');
    }
  }
}

/**
 * @param {String} title
 * @param {String} body
 */
export function replaceElModalRemoveCartForm(title, body) {
  const formTitle = document.querySelector('#modalRemoveInCart #modalMessageLabel');
  const formDisc = document.querySelector('#modalRemoveInCart .modal-body .message');

  formTitle.innerHTML = title;
  formDisc.innerHTML = body;
}
